/* Accordian Start */
function slideUp(element, duration = 300) {
    element.style.height = element.scrollHeight + "px";
    element.offsetHeight; // force repaint

    element.style.transition = `height ${duration}ms ease`;
    element.style.height = "0px";
    element.style.overflow = "hidden";

    setTimeout(() => {
        element.style.display = "none";
        element.style.removeProperty("height");
        element.style.removeProperty("overflow");
        element.style.removeProperty("transition");
    }, duration);
}

function slideDown(element, duration = 300) {
    element.style.display = "block";
    let height = element.scrollHeight;

    element.style.height = "0px";
    element.style.overflow = "hidden";
    element.offsetHeight;

    element.style.transition = `height ${duration}ms ease`;
    element.style.height = height + "px";

    setTimeout(() => {
        element.style.removeProperty("height");
        element.style.removeProperty("overflow");
        element.style.removeProperty("transition");
    }, duration);
}

function scrollAccordionItemIntoView(item, question) {
    const container = item.closest(".Product_meta_collapsible_main_new");
    if (!container) return;

    const offset = 100;
    const y = question.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
        top: y,
        behavior: "smooth"
    });
}

function observeAccordionExpansion(item, question, answer) {
    if (typeof ResizeObserver === "undefined") {
        window.setTimeout(() => {
            if (item.classList.contains("open")) {
                scrollAccordionItemIntoView(item, question);
            }
        }, 300);
        return;
    }

    const initialHeight = answer.getBoundingClientRect().height;
    let hasScrolled = false;

    const resizeObserver = new ResizeObserver(() => {
        if (hasScrolled || !item.classList.contains("open")) {
            resizeObserver.disconnect();
            return;
        }

        const currentHeight = answer.getBoundingClientRect().height;
        if (currentHeight <= initialHeight) return;

        hasScrolled = true;
        resizeObserver.disconnect();

        window.requestAnimationFrame(() => {
            if (item.classList.contains("open")) {
                scrollAccordionItemIntoView(item, question);
            }
        });
    });

    resizeObserver.observe(answer);
}

function initCustomAccordion(root) {
    const scope = root || document;

    scope.querySelectorAll(".accordion").forEach(acc => {
        const items = acc.querySelectorAll("li");

        items.forEach(item => {
            if (item.dataset.accordionBound === "true") return;
            item.dataset.accordionBound = "true";

            const question = item.querySelector(".question");
            const answer = item.querySelector(".answer");

            if (!question || !answer) return;

            // Initial state
            if (item.classList.contains("open")) {
                answer.style.display = "block";
            } else {
                answer.style.display = "none";
            }

            question.addEventListener("click", () => {
                const isOpen = item.classList.contains("open");

                // Close others
                items.forEach(i => {
                    if (i === item) return;
                    i.classList.remove("open");

                    const a = i.querySelector(".answer");
                    if (a && a.style.display !== "none") {
                        slideUp(a, 300);
                    }
                });

                // Toggle current
                if (isOpen) {
                    item.classList.remove("open");
                    slideUp(answer, 300);
                } else {
                    item.classList.add("open");
                    observeAccordionExpansion(item, question, answer);
                    slideDown(answer, 300);
                }
            });
        });
    });
}

window.initCustomAccordion = initCustomAccordion;
initCustomAccordion(document);
/* Accordian End */
